import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ShButtonComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-payout-success',
    templateUrl: './payout-success.component.html',
    imports: [ShButtonComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: { class: 'flex flex-1 flex-col' }
})
export class PayoutSuccessComponent {
    private router = inject(Router);

    public onBackToHome(): void {
        this.router.navigate(['/']);
    }
}
